import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ConversationSelectors } from "redux-store";
import { createSelector } from "reselect";

const memoizedDisappearList = createSelector(
  [
    ConversationSelectors.getSelectedGroupId,
    ConversationSelectors.getThreadingId,
    state => state.conversationRedux.disappearMsg,
  ],
  (selectedGroupId, selectedThreadId, disappearMsg) => {
    let disappearMsgIdsRedux = [];
    if (selectedThreadId) {
      disappearMsgIdsRedux = disappearMsg.filter(item => item.thread_id === selectedThreadId).map(item => item.id);
    } else if (selectedGroupId) {
      disappearMsgIdsRedux = disappearMsg.filter(item => item.group_id === selectedGroupId).map(item => item.id);
    }

    return { disappearMsgIdsRedux };
  },
);

const useDisappearMessage = ({ onCallback }) => {
  const { disappearMsgIdsRedux } = useSelector(memoizedDisappearList);

  const [disappearListId, setDisappearListId] = useState([]);

  const handleSetDisappearListId = listId => {
    setDisappearListId(state => [...state, ...listId]);
  };

  useEffect(() => {
    if (Array.isArray(disappearMsgIdsRedux) && disappearMsgIdsRedux.length > 0) {
      handleSetDisappearListId(disappearMsgIdsRedux);
      if (onCallback) onCallback(disappearMsgIdsRedux);
    } else {
      setDisappearListId([]);
    }
  }, [disappearMsgIdsRedux]);

  return { disappearListId };
};

export default useDisappearMessage;
